import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=a2b46496&"
import script from "./pic.vue?vue&type=script&lang=js&"
export * from "./pic.vue?vue&type=script&lang=js&"
import style0 from "./pic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2b46496')) {
      api.createRecord('a2b46496', component.options)
    } else {
      api.reload('a2b46496', component.options)
    }
    module.hot.accept("./pic.vue?vue&type=template&id=a2b46496&", function () {
      api.rerender('a2b46496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/xinfang/pic.vue"
export default component.exports